import { Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { data } from "src/app/audit-trail/application/data";
import { AuditTrailService } from "src/app/audit-trail/audit-trail.service";
import { LotteryFormResponse } from "src/app/model/LotteryFormResponse";
import { ExportImportService } from "src/app/services/export-import.service";
import { PublishLettersService } from "src/app/services/publish-letters.service";
import { ReportService } from "src/app/services/report.service";

@Component({
  selector: "app-secure-download-applicant-pan-adhar-pol-zip",
  templateUrl: "./download-applicant-pan-adhar-pol-zip.component.html",
  styleUrls: ["./download-applicant-pan-adhar-pol-zip.component.scss"],
})
export class DownloadApplicantPanAdharPolZipComponent implements OnInit {
  [x: string]: any;
  form: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  lotteryList: {[key: number]: string};
  isSubmitDisabled: boolean = false;
  downloadedBatches: string[] = [];
  boards: {[key: number]: string};
  board:any;
  lottery:any;
  scheme:any;
  

  
  constructor(
    private router: Router,
    private exportImportService: ExportImportService,
    private reportService:ReportService,
    private publishLetterService: PublishLettersService,
    private auditTrailService: AuditTrailService
    , private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {

    this.reportService.initQueryExecutorForm().subscribe((data)=>{
      this.boards= data.boards;
      console.log(data);
    })

    // this.publishLetterService
    // .publishDocumentsInitForm()
    // .subscribe((data: any) => {
    //    this.isLoading = false;
    //     this.lotteryList = data.lotteryList;
    // }, error => {
    //   this.isLoading = false;
    //   this.publishLetterService.errorToast(error.errorMessage||error.error.errorMessage);
    // });
  
  }



 
  refresh() {
    this.loadData();
  }

  downloadFile(base64:string | ArrayBuffer, fileName:string){
    const src = `${base64}`;
    const link = document.createElement("a")
    link.href = src
    link.download = fileName
    link.click()
    
    link.remove()
  }

  onSubmit() {

    if(this.form.value.applicationNo !==null ){
      console.log(this.form.value.applicationNo);
      this.exportImportService.downloadPol(this.form.value.applicationNo)
      .subscribe((data) => {
        this.isLoading = false;
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.downloadedBatches.push(this.form.value.applicationNo);
          this.downloadFile(data.base64File, data.fileName);
          this.successToast();
        }
        else {
          this.exportImportService.errorToast(data.errorMessage);  
        }
      }, error => {
        this.isLoading = false;
        this.exportImportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
        // this.exportImportService.errorToast("Please Enter Application Number:"+this.form.value.applicationNo);

      });
  
    } else {
      this.exportImportService.errorToast("Please Enter Application Number");  
    }

    
  }
  async successToast() {
    await this._snackBar.open(
        " Applicant Docs Successfully Downloaded",
        "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
        }
    );
}

// onBoardChange(){
//   this.auditTrailService.changeLottery(this.board)
//   .subscribe((data:LotteryFormResponse) => {
//     this.lotteryList=data.lotterylist;

//   });
// }

onBoardChange(boardId:any){
  this.board=boardId
  this.auditTrailService.changePmayLottery(this.board)
  .subscribe((data:LotteryFormResponse) => {
    this.lotteryList=data.lotterylist;
    this.BoardValue=!!boardId;
    this.schemeList= [];

console.log(this.lotteryId)
  });
}

onLotteryChange(lotteryId:any){
  this.lottery=lotteryId,
  this.auditTrailService.getSchemeNameService(lotteryId)
  .subscribe((data:LotteryFormResponse) => {
    this.schemeList=data.schemeList;
this.lotteryValue=!!lotteryId
    
    console.log(this.schemeList)

  });
}

downloadApplicantDocument() {
    this.isLoading = true;
    console.log(this.board);
    console.log(this.lottery);
    console.log(this.scheme);
    // console.log(this.startDate);
    // console.log(this.endDate);
    this.auditTrailService.downloadApplicantDocs({board:this.board,lottery:this.lottery,scheme:this.scheme})
    .subscribe((data) => {
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        this.downloadedBatches.push(this.data?.scheme);
        this.downloadFile(data.base64File, data.fileName);
        this.successToast();
      }
      else {
        this.exportImportService.errorToast(data.errorMessage);  
      }
    }, error => {
      this.isLoading = false;
      this.exportImportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
    });


  
}





  // board(board: any) {
  //   throw new Error("Method not implemented.");
  // }
  // lottery(lottery: any) {
  //   throw new Error("Method not implemented.");
  // }





}